import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { selectors as betSelectors, actions as betActions } from '../../../common/bet';
import BetReceipt from './components/BetReceipt';
import Svg from '../../../common/svgIcon';
import { formatDateTime } from '../../../common/utils/formatDateTime';
import { selectors as userInfoSelectors } from '../../../common/userInfo';
import { selectors as pageInfoSelectors } from '../../../common/pageInfo';
import { actions as bookmakersInfoActions } from '../../../common/bookmakersInfo';
import * as drawerActions from '../../drawer.actions';
import { selectors as bookmakersListSelectors } from '../../../common/bookmakersList';
import {
    calculateSingleStake,
    calculateMultipleStake,
} from '../../../common/utils/calculateStake';
import { getCurrentDate } from '../../../common/utils/currentDate';
import PRICE_TYPES from '../../../common/utils/priceTypes'
import './styles.scss';

const selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

export class BetReceiptPage extends Component {

    reuseSelection = () => {
        const {
            placedBetDetails,
            clearPlacedBetDetails,
            addSelectedBet,
            unusedBets,
            clearUnusedBets,
            clearAllErrors,
        } = this.props

        // Restore bets that were placed (only singles)
        // Note that fresh multiples will be generated
        placedBetDetails.bets.forEach((placedBet) => {
            const {
                betType,
                bets,
            } = placedBet
            if (betType === 'single') {
                const singleBet = bets[0]
                const priceType = (singleBet.isSpOnly)
                    ? PRICE_TYPES.SP
                    : PRICE_TYPES.ODDS
                const bet = {
                    ...singleBet,
                    stake: '',
                    isEachWay: false,
                    isLockedStake: false,
                    priceType,
                }
                addSelectedBet(bet)
            }
        })

        // Restore bets that were added, but not placed (i.e. had blank stake when placed)
        unusedBets.forEach((unusedBet) => {
            addSelectedBet(unusedBet)
        })

        // Clear unused bets
        clearUnusedBets()

        // Clear the placed bet
        clearPlacedBetDetails()

        // Clear errors
        clearAllErrors()
    };

    clearPlacedBetDetails = () => {
        const {
            clearPlacedBetDetails,
            setQuickslipMode,
         } = this.props;

        setQuickslipMode(true);
        clearPlacedBetDetails();
        document.dispatchEvent(selectionRemovedEvent);
    };

    render() {
        const {
            placedBetDetails,
            userInfo,
            useDecimalOdds,
        } = this.props;
        if (placedBetDetails.bets.length === 0) {
            return (<Redirect
                to={{
                    pathname: '/',
                    state: { isReversedAnimation: true },
                }}
            />);
        }
        const { currencySign } = userInfo;
        const receipts = placedBetDetails.bets.map((placedBet) => {
            const {
                betId,
                betType,
                receiptId,
                bets,
                multiple,
                stakePerLine,
                numberLines,
                potentialReturns,
            } = placedBet

            let totalStake
            let isEachWay

            if (betType === 'single') {
                totalStake = calculateSingleStake(bets[0])
                isEachWay = bets[0].isEachWay
            } else {
                totalStake = calculateMultipleStake(multiple)
                isEachWay = multiple.isEachWay
            }

            const potentialReturnsString = (potentialReturns !== null) ?
                potentialReturns.toString() :
                'N/A';

            return (
                <BetReceipt
                    key={`receipt-${receiptId}-${betId}`}
                    receiptId={receiptId}
                    betType={betType}
                    selections={bets}
                    currencySign={currencySign}
                    stake={totalStake}
                    totalStake={totalStake}
                    returns={potentialReturnsString}
                    isEachWay={isEachWay}
                    useDecimalOdds={useDecimalOdds}
                    stakePerLine={stakePerLine}
                    numberLines={numberLines}
                    freeBet={placedBetDetails.freeBet}
                />
            )
        });

        const timeBetPlaced = formatDateTime(getCurrentDate());
        const pendingMessage = !placedBetDetails.containsPending
            ? null
            : (
                <div className="bs-betReceiptPage__pendingMessage">
                    <h2 className="bs-betReceiptPage__pendingMessage--title">
                        Your Bet is Pending...
                    </h2>
                    <p className="bs-betReceiptPage__pendingMessage--explanation">
                        This bet was submitted very close to the off, we are checking
                        to see if we can successfully place this bet,
                        this could take up to 2 minutes.
                    </p>
                    <p className="bs-betReceiptPage__pendingMessage--explanation">
                        Please check your Bet History to see if this
                        bet was successfully placed.
                    </p>
                </div>
            )
        const barTitle = placedBetDetails.containsPending
            ? 'Your Pending Bets'
            : 'Your Bets'

        return (
            <div className="bs-horizontalSlider__container">
                <div className="bs-horizontalSlider__element bs-betReceiptPage">
                    <div className="bs-drawer__scrollable">
                        <div className="bs-betReceiptPage__dateTimeBar">
                            <div className="bs-betReceiptPage__dateTimeBar--title">
                                <Svg
                                    iconName="bet-success"
                                    className="bs-betReceiptPage__tick"
                                />
                                <span>
                                    Bet Placed Successfully
                                </span>
                            </div>
                            <span className="bs-betReceiptPage__dateTimeBar--dateTime">
                                {timeBetPlaced}
                            </span>
                        </div>
                        {pendingMessage}
                        <div className="bs-betReceiptPage__yourBetsBar">
                            <span>{barTitle} ({receipts.length})</span>
                        </div>
                        {receipts}
                    </div>
                    <div className="bs-drawer__actionBar">
                        <div className="bs-actionBar bs-section">
                            <button
                                className={
                                    `bs-btn
                                    bs-btn_default
                                    bs-actionBar__button
                                    bs-actionBar__large`
                                }
                                onClick={this.reuseSelection}
                            >
                                <span>Reuse Selection</span>
                            </button>
                            <button
                                className={
                                    `bs-btn
                                    bs-btn_major
                                    bs-actionBar__button
                                    bs-actionBar__large
                                    bs-betReceipt__doneButton`}
                                onClick={this.clearPlacedBetDetails}
                            >
                                <span>Done</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const betProp = PropTypes.shape({
    raceTime: PropTypes.string.isRequired,
    raceDate: PropTypes.string.isRequired,
    courseName: PropTypes.string.isRequired,
    horseName: PropTypes.string.isRequired,
    fractionalPrice: PropTypes.string.isRequired,
    decimalPrice: PropTypes.number,
    isSpOnly: PropTypes.bool.isRequired,
    eachWayFraction: PropTypes.string,
    eachWayPlaces: PropTypes.string,
    priceType: PropTypes.string.isRequired,
    isBog: PropTypes.string,
    isEachWay: PropTypes.bool,
    stake: PropTypes.string,
})

BetReceiptPage.defaultProps = {
    placedBetDetails: null,
    useDecimalOdds: false,
    unusedBets: [],
}

BetReceiptPage.propTypes = {
    userInfo: PropTypes.shape({
        name: PropTypes.string,
        currencySign: PropTypes.string,
        balance: PropTypes.number,
        showBalance: PropTypes.bool,
    }).isRequired,
    placedBetDetails: PropTypes.shape({
        containsPending: PropTypes.bool.isRequired,
        freeBet: PropTypes.shape({
            id: PropTypes.string.isRequired,
            type: PropTypes.string,
            amount: PropTypes.number.isRequired,
            minStake: PropTypes.number,
            maxStake: PropTypes.number,
        }),
        bets: PropTypes.arrayOf(PropTypes.shape({
            betType: PropTypes.string,
            eachWayFlag: PropTypes.bool,
            receiptId: PropTypes.string,
            stakePrice: PropTypes.number,
            totalStake: PropTypes.number,
            estimatedReturns: PropTypes.number,
            bet: betProp,
        })).isRequired,
    }),
    useDecimalOdds: PropTypes.bool.isRequired,
    clearPlacedBetDetails: PropTypes.func.isRequired,
    setQuickslipMode: PropTypes.func.isRequired,
    addSelectedBet: PropTypes.func.isRequired,
    unusedBets: PropTypes.arrayOf(betProp).isRequired,
    clearUnusedBets: PropTypes.func.isRequired,
    clearAllErrors: PropTypes.func.isRequired,
}

const userInfoSelector =
    userInfoSelectors.createUserInfoSelector(
        betSelectors.placedBetBookmakerSelector,
    );

const bookmakerInfoSelector = bookmakersListSelectors.createBookmakerInfoSelector(
    betSelectors.placedBetBookmakerSelector,
);

const mapStateToProps = (state, props) => {
    const { placedBetDetails } = state.bet;

    return {
        ...bookmakerInfoSelector(state, props),
        placedBetDetails,
        userInfo: userInfoSelector(state, props),
        feed: betSelectors.placedBetBookmakerSelector(state),
        useDecimalOdds: pageInfoSelectors.useDecimalOddsSelector(state),
        unusedBets: state.bookmakersInfo.unusedBets,
    };
};

const mapDispatchToProps = {
    clearPlacedBetDetails: betActions.clearPlacedBetDetails,
    setQuickslipMode: drawerActions.setQuickslipMode,
    addSelectedBet: bookmakersInfoActions.addSelectedBet,
    clearUnusedBets: bookmakersInfoActions.clearUnusedBets,
    clearAllErrors: bookmakersInfoActions.clearAllErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(BetReceiptPage);



// WEBPACK FOOTER //
// /src/js/drawer/components/BetReceiptPage/BetReceiptPage.jsx